import axios from 'axios';
import { API_BASE_URL } from './config';

const getAllLicenses = async () => {
    const response = await axios.get(`${API_BASE_URL}/auto-license`);
    return response.data;
};

const getLicense = async (id) => {
    const response = await axios.get(`${API_BASE_URL}/auto-license/${id}`);
    return response.data;
};

const createLicense = async (licenseData) => {
    const response = await axios.post(`${API_BASE_URL}/auto-license`, licenseData);
    return response.data;
};

const updateLicense = async (id, licenseData) => {
    const response = await axios.put(`${API_BASE_URL}/auto-license/${id}`, licenseData);
    return response.data;
};

const deleteLicense = async (id) => {
    const response = await axios.delete(`${API_BASE_URL}/auto-license/${id}`);
    return response.data;
};

const autoLicenseService = {
    getAllLicenses,
    getLicense,
    createLicense,
    updateLicense,
    deleteLicense
};

export default autoLicenseService;